<template>
  <BaseTemplate :currentUser="currentUser">
    <div class="privacy-protection">
      <Title jpn="Privacy Statement" />
      <div class="scroll-container">
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">We ask you to provide us with personal information, which also makes you use our services with peace of mind.</span>
            <span class="text">In addition, we pay the utmost attention to the protection of the personal information you provide.</span>
            <br>
            <span class="text">Our approach to personal information protection is as follows</span>
            <span class="text">(1) We use personal, group, and corporate information registered by members only for the purpose of developing and providing cutting-edge functions and services, and pay close attention to the protection of member personal information.</span>
            <span class="text">(2) This privacy policy applies only to the Services provided by our Company.</span>
            <span class="text">(3) We will not use it for any purpose other than the purpose specified in this agreement.</span>
            <span class="text">(4) We will not disclose personal information to third-parties except as specified in this agreement.</span>
            <span class="text">(5) In addition, we will regularly perform appropriate management by the method stipulated in this agreement.</span>
            <span class="text">(6) We may change the privacy policy without the user's permission.</span>
            <span class="text">When we change the content of personal information acquisition, change the method of use, change the content of disclosure, etc., we will publish it on our website notice so that users can know the content and this privacy policy.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title="SECTION 1: SCOPE OF APPLICATION OF OUR PRIVACY POLICY"
        >
          <div class="text-container">
            <span class="text">(1) Our Company's privacy policy applies when members use our Company's services.</span>
            <span class="text">(2) Personal information collected when members use our services will be managed by our Company's approach to personal information protection.</span>
            <span class="text">(3) Our approach to personal information protection applies only to services directly provided by our Company and does not apply to services of other organizations or companies.</span>
            <span class="text">(4) The use of our services shall be done at the user's responsibility.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title="SECTION 2: OUR COLLECTION AND USE OF PERSONAL INFORMATION"
        >
          <div class="text-container">
            <span class="text">1. In order to develop and provide state-of-the-art functions and services to our members, we need some of your personal information.</span>
            <span class="text">2. Please manage your registered email address and password at your own responsibility.</span>
            <span class="text indent">(1) We recommend that you change your password regularly and do not use names, dates of birth, phone numbers, etc. that can be easily guessed by others.</span>
            <span class="text indent">(2) Do not disclose, lend, or transfer personal information, even if it is an acquaintance or friend.</span>
            <span class="text">3. Collected personal information will be used only to the extent necessary to provide our services, and will not be provided to any third-party except in the following cases.</span>
            <span class="text indent">(1) When there is an inquiry from the credit card company to investigate fraudulent use of the card.</span>
            <span class="text indent">(2) When sending e-mails or direct emails for advertising to members.</span>
            <span class="text indent">(3) When entrusting the handling of personal information to a subcontractor that has concluded a confidentiality agreement regarding personal information to the extent necessary to achieve the purpose of use specified to the user.</span>
            <span class="text indent">(4) When it is deemed necessary to protect the rights and property of other members, third-parties, or our Company when the member's actions at our Company violate our Company's policies, notices, terms of use, etc...</span>
            <span class="text indent">(5) When disclosure of personal information is requested in accordance with the provisions of other laws, such as orders from courts or administrative agencies, or when there is a need to investigate crimes, eliminate or prevent infringement of third-parties, or other equivalent cases.</span>
            <span class="text">4. The member shall agree in advance to the use of personal information by the method specified above, and shall not raise any objection.</span>
            <span class="text">5. In addition, in the following cases, we may share the personal information of members with our business partners.</span>
            <span class="text indent">(1) When there is a business reason such as a special service for members. In this case, we will ask for the consent of the member before providing the information, and will not provide it without consent.</span>
            <span class="text indent">(2) When creating statistical materials, market research, and data analysis. In this case, we will only provide information that has been processed so that it is not possible to identify a specific individual.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title="Contact information"
        >
          <div class="text-container">
            <span class="text">If you have any questions about the way of thinking about personal information shown here.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title="minny"
        >
          <div class="text-container">
            <span class="text">
              <a href="https://minny-online-store.iranoan.com/contacts?service=1" target="_blank">
                Please contact us by "inquiry form" from the following minny online store.
              </a>
            </span>
          </div>
        </ShadowBoxTitleDescription>
      </div>
    </div>
  </BaseTemplate>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseTemplate from '@/components/templates/BaseTemplate.vue';
import ShadowBoxTitleDescription from '@/components/molecules/ShadowBoxTitleDescription.vue';
import Title from '@/components/molecules/Title.vue';
import t from '@/plugins/i18n';

export default {
  name: 'TermsOfService',
  mixins: [t],

  components: {
    BaseTemplate,
    ShadowBoxTitleDescription,
    Title,
  },

  computed: {
    ...mapGetters({
      currentUser: 'user/currentUser',
    }),
  },

  created() {
    this.$store.dispatch('user/setCurrentUser', { token: 'yugi' });
  },
};
</script>

<style lang="scss" scoped>
.privacy-protection{
  width: 100%;
  max-width: 1600px;
  min-height: 100%;
  padding: 30px 20px 0;
  margin: 0 auto;
  color: $white;
  .privacy-protection-title{
    display: flex;
    justify-content: center;
    .text{
      height: 35px;
      font-family: $notoSerif;
      font-size: 24px;
      font-weight: 700;
    }
  }
  .scroll-container{
    width: 100%;
    margin-top: 30px;
    padding-bottom: 50px;
    max-width: 1000px;
    margin-left: auto;
    margin-right: auto;
    .shadow-box-title-description{
      width: 100%;
      .text-container{
        display: flex;
        flex-direction: column;
        padding: 5px 5px 0 5px;
        .text{
          font-family: $notoSans;
          font-size: 13px;
          line-height: 1.5;
          letter-spacing: 0.03em;
          color: $white;
          a {
            color: $white!important;
          }
          &.margin-top{
            margin-top: 10px;
          }
          &.one-line-space-top{
            margin-top: 1em;
          }
          &.indent{
            padding-left: 2.6em;
            text-indent: -1.6em;
          }
        }
      }
      & + .shadow-box-title-description{
        margin-top: 40px;
      }
    }
  }
}
</style>
